import { cx } from '@linaria/core';
import { useSearchParams } from 'next/navigation';
import { useRef } from 'react';

import { usePathname } from '~i18n/navigation';
import { SmartElement } from '~shared/ui/atoms/Buttons/SmartElement';
import { updateQueryParamsWithPathname } from '~utils/searchParams';

import type {
	BotWizardField,
	BotWizardFieldNames,
	BotWizardValues,
	BotWizardValueSimple,
} from '../../model/types';
import { styledItem } from './styles';

export const ProgressItem = ({
	values,
	index,
	disabled,
}: {
	values: BotWizardValues;
	fields: Record<BotWizardFieldNames, BotWizardField>;
	index: number;
	disabled?: boolean;
}) => {
	const ref = useRef<HTMLAnchorElement>(null);

	const pathname = usePathname();
	const searchParams = useSearchParams();
	const selected = index < parseInt((values.step as BotWizardValueSimple)!);

	const isCurrent = index === parseInt((values.step as BotWizardValueSimple)!);
	if (!values.path || !values.step) {
		return null;
	}

	// const getStepKeys = () => {
	// 	if (values.path === '1' || index === 0) {
	// 		return firstStep;
	// 	} else {
	// 		return getDependencyStep({
	// 			step: presetSteps[index - 1],
	// 			values,
	// 			contentDependency: ['gender'],
	// 		});
	// 	}
	// };
	// const keys = getStepKeys();

	return (
		<>
			<SmartElement
				className={cx(
					styledItem,
					selected && 'selected',
					isCurrent && 'current'
				)}
				disabled={isCurrent || disabled || !selected}
				href={updateQueryParamsWithPathname(
					{ step: index },
					pathname,
					searchParams
				)}
				ref={ref}
			>
				<div />
			</SmartElement>
			{/*Next iteration*/}
			{/*{selected && (*/}
			{/*	<Preview*/}
			{/*		keys={keys}*/}
			{/*		stepNumber={index}*/}
			{/*		targetRef={ref}*/}
			{/*		values={values}*/}
			{/*		fields={fields}*/}
			{/*	/>*/}
			{/*)}*/}
		</>
	);
};
